/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect } from 'react';
import { useDispatch } from 'react-redux';
import TextField from '@material-ui/core/TextField';
import { Button } from 'react-bootstrap';
import CustomCarousel from './CustomCarousel';
import ArrowForwardIcon from '@material-ui/icons/ArrowForward';
import PasswordForm from './PasswordForm';
import * as LoginConstants from './LoginConstants';
import * as AppConstants from '../../../SharedModule/Utils/AppConstants';
import ErrorMessages from '../../../SharedModule/MessageHandlers/ErrorMessages';
import Spinner from '../../../SharedModule/Spinner/Spinner';
import { resetLoginData } from '../Store/Actions/LoginActions';
import { resetLogoutData } from '../../../SharedModule/Store/Actions/AppActions';

export default function LoginForm(props) {
    const dispatch = useDispatch();
    let errorMessagesArray = [];
    const [showPassword, setShowPassword] = React.useState(false);
    const [errorMessages, setErrorMessages] = React.useState([]);
    const [spinnerLoader, setSpinnerLoader] = React.useState(false);
    const [{
        userIDError
    }, setShowError] = React.useState(false);
    const [{
        userIDErrorText
    }, setShowErrorText] = React.useState('');

    // Field bindings
    const [values, setValues] = React.useState({
        userId: ''
    });

    useEffect(() => {
        sessionStorage.removeItem('authToken');
        sessionStorage.removeItem('disableClaimsOption');
        dispatch(resetLoginData('loginUser'));
        dispatch(resetLogoutData('appConfigDropdown'));
        dispatch(resetLogoutData('logout'));
        dispatch(resetLogoutData('refreshToken'));
    }, []);

    // Method to set field values on change
    const handleChanges = name => event => {
        setValues({ ...values, [name]: event.target.value });
    };

    // Method to validate Login Form
    const validateLoginForm = () => {
        errorMessagesArray = [];
        setErrorMessages([]);
        var userIDError = false;
        var userIDErrorText = '';

        if (values.userId === '' || (values.userId && values.userId.trim() === '')) {
            userIDError = true;
            userIDErrorText = LoginConstants.USER_ID + LoginConstants.REQUIRED;
            errorMessagesArray.push(userIDErrorText);
        }
        if (!userIDError && !AppConstants.USER_ID_REGEX.test(values.userId)) {
            userIDError = true;
            userIDErrorText = AppConstants.USER_ID_INVALID;
            errorMessagesArray.push(userIDErrorText);
        }

        setErrorMessages(errorMessagesArray);
        setShowError({
            userIDError: userIDError
        });
        setShowErrorText({
            userIDErrorText: userIDErrorText
        });

        if (errorMessagesArray && errorMessagesArray.length > 0) {
            return true
        } else {
            return false;
        }
    };

    // Method to submit Login Form
    const submitLoginForm = () => {
        dispatch(resetLogoutData('logout'));
        if (!validateLoginForm()) {
            setShowPassword(true);
        }
    };

    return (
        <div className="container-xl">
            <div className="text-float pb-1"></div>
            {spinnerLoader ? <Spinner /> : null}
            {errorMessages && errorMessages.length > 0 ?
                <div className="login-tab-error pt-4">
                    <div className="form-wrapper col-sm-12 p-0">
                        <ErrorMessages errorMessages={errorMessages} />
                    </div>
                </div> : null}
            <div className="contact-us-block font-weight-600">
                <a href="/contactUs" target="_blank">Contact Us</a>
                <span className="blue-font px-1">|</span>
                <a href="/Help" target="_blank">Help</a>
            </div>
            <div className="login-tab">
                <div className="row vertical-wrapper">
                    <div className="show-on-md col px-lg-1">
                        <CustomCarousel />
                    </div>

                    {(!showPassword) ?
                        <>
                            <div className="col px-lg-0">
                                <div className="login-header">
                                    <span className="float-left">LOGIN</span>
                                    <a href="/adminLogin" className="float-right pr-1">
                                        <img src="Admin logo.svg" alt="Admin Logo" className="pr-2 admin-logo" />Admin Login
                                    </a>
                                </div>
                                <div className="login-form-container">
                                    <form autoComplete="off" onSubmit={e => { e.preventDefault(); }}>
                                        <div className="p-2">
                                            <div className="form-wrapper col pl-0">
                                                <div className="mui-custom-form m-3">
                                                    <TextField
                                                        id="standard-userId"
                                                        required
                                                        label={LoginConstants.USER_ID}
                                                        fullWidth
                                                        value={values.userId}
                                                        onChange={handleChanges('userId')}
                                                        placeholder=""
                                                        inputProps={{ maxLength: 30 }}
                                                        InputLabelProps={{
                                                            shrink: true
                                                        }}
                                                        error={userIDError}
                                                        helperText={userIDError ? userIDErrorText : null}
                                                    />
                                                </div>
                                                <div className="mui-custom-form mx-3 my-2">
                                                    <Button className='btn btn-primary btn-primary-login-sm' onClick={submitLoginForm}>
                                                        ENTER </Button>
                                                    <a href="/forgotUserID" className="font-weight-600 pl-3">Forgot User ID?</a>
                                                </div>
                                            </div>
                                        </div>
                                    </form>
                                </div>
                                <div className="mt-3">
                                    <a href="/registration">
                                        <div className="admin-footer-container py-3 text-center align-middle font-weight-600">
                                            New User Register Here<ArrowForwardIcon className="px-1" />
                                        </div>
                                    </a>
                                </div>
                            </div>
                        </>
                        :
                        <PasswordForm userID={values.userId} setValues={setValues} history={props.history} setShowPassword={setShowPassword}
                            setErrorMessages={setErrorMessages} setSpinnerLoader={setSpinnerLoader} />
                    }
                </div>
                <div className="show-on-xs">
                    <CustomCarousel />
                </div>
            </div>
        </div>
    )
}
